module.exports = __webpack_public_path__ + "img/pf.4c112e5a.svg";